import Form from 'Scripts/common/form';

export default class SwiftaidSettings {
    constructor() {
        this.form = new Form({
            form: $('#js-swiftaid-form'),
            callback: (data) => {
                window.location.reload();
            }
        });

        this.ignoredForm = new Form({
            form: $('#js-swiftaid-ignore-form'),
            callback: (data) => {
                window.location = "/dashboard";
            }
        });
    } 
}